import { ACTUAL_DIRECTION_VALUE } from '../types';

export default (directionType, actualValue) => ({
  type: ACTUAL_DIRECTION_VALUE,
  directionType,
  actualValue,
});
